import React from 'react'
import { useTranslation } from 'react-i18next'

import useStyles from './styles'

const CreateLeadAdsFormLink = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <p>{t('Lead Ads forms should be created in your Meta Business Manager account before proceeding.')}</p>
      <p>
        <a
          href="https://business.facebook.com/latest/instant_forms/forms/"
          className={classes.createLeadAdsFormLink}
          target="_blank"
          rel="noreferrer nofollow"
        >
          {t('Click here')}
        </a>{' '}
        {'to create a Lead Ads form.'}
      </p>
    </>
  )
}

export default CreateLeadAdsFormLink
